import {useState} from "react";
import {useNavigate} from "react-router-dom";

export function AdminPage() {
    const [password, setPassword] = useState("")
    const navigate = useNavigate()

    function savePassword(e) {
        e.preventDefault()

        localStorage.setItem('password', password)

        navigate("/")
    }

    return (
        <form className="max_size" onSubmit={savePassword}>
            <h1>Админ панель</h1>
            <input
                name="password"
                type="password"
                placeholder="Пароль от панели"
                autoComplete="password"
                onChange={e => setPassword(e.target.value)}
                value={password}
            />
            <button
                type="submit"
            >
                Отправить
            </button>
        </form>
    )
}